// Production environment
export const environment = {
  production: true,
  apiUrl: 'https://leora-h5cxbvdscfghgzcg.westeurope-01.azurewebsites.net/api',
  appName: 'Leora Sandbox UI'
};
